import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const getAllPackageNames = (tokens: any, fileType: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.routingPackageNames),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      fileType: fileType ?? 0
    }
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getAllPackageNames }
